const normalizeRole = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

export const isSuperAdminRole = (value) => {
  const role = normalizeRole(value);
  return role === "super_admin" || role === "superadmin" || role.includes("super");
};

export const isStaffAccountRole = (value) => normalizeRole(value) === "staff";

export const normalizeManagedAccountRole = (value) => {
  if (isSuperAdminRole(value)) return "super_admin";
  if (isStaffAccountRole(value)) return "staff";
  return "admin";
};

export const canManageTargetAccount = (actorIsSuperAdmin, targetRole) => {
  if (actorIsSuperAdmin) return true;
  return isStaffAccountRole(targetRole);
};

export const defaultPromoteRole = (actorIsSuperAdmin) =>
  actorIsSuperAdmin ? "admin" : "staff";
